import { FC, SVGProps } from 'react'

export const PenIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.4998 4.49725L17.3282 7.32623M12 19.9996H20M2 20L2.04745 19.6678C2.21536 18.4922 2.29932 17.9044 2.49029 17.3556C2.65975 16.8687 2.89124 16.4056 3.17906 15.9778C3.50341 15.4957 3.92319 15.0758 4.76274 14.2362L16.4107 2.5859C17.1918 1.80471 18.4581 1.8047 19.2392 2.5859C20.0202 3.3671 20.0202 4.63368 19.2392 5.41488L7.37744 17.2789C6.61579 18.0407 6.23497 18.4216 5.8012 18.7246C5.41618 18.9934 5.00093 19.2161 4.56398 19.3882C4.07171 19.5819 3.54375 19.6884 2.48793 19.9016L2 20Z"
        stroke="#000000"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
